import { Content, ProductError, ProductErrorType } from '../../models';
import { v4 as uuidv4 } from 'uuid';
export class VerticalMenuData {
  items: VerticalMenuItem[];

  constructor(verticalMenu?: VerticalMenuData) {
    this.items = verticalMenu?.items?.map(item => new VerticalMenuItem(item)) || [];
  }

  static validate(verticalMenu: VerticalMenuData, payloadData: any): ProductError[] {
    const errors: ProductError[] = [];

    if (!verticalMenu.items || !verticalMenu.items.length) {
      errors.push({ type: ProductErrorType.MISSING, property: 'items', payload: { ...payloadData } });
    }

    if (verticalMenu.items.length > 6) {
      errors.push({ type: ProductErrorType.TOO_MUCH_VALUES, property: 'items', payload: { ...payloadData } });
    }

    errors.push(
      ...verticalMenu.items.flatMap((item, itemIndex) =>
        VerticalMenuItem.validate(item, { ...payloadData, itemIndex }),
      ),
    );

    return errors;
  }
}

export class VerticalMenuItem {
  uuid: string;
  title: string;
  contents: Content[];
  isOpenByDefault: boolean;

  constructor(item?: VerticalMenuItem) {
    this.uuid = item?.uuid ?? uuidv4();
    this.title = item?.title ?? null;
    this.contents = item?.contents?.map(c => new Content(c)) ?? null;
    this.isOpenByDefault = item?.isOpenByDefault ?? false;
  }

  static validate(item: VerticalMenuItem, payloadData: any): ProductError[] {
    const errors: ProductError[] = [];

    errors.push(
      ...ProductError.validatePrimitiveTypes(item, ['title', 'uuid'], []).map(error => ({
        ...error,
        payload: { ...payloadData },
      })),
    );

    if (!item.contents || !item.contents.length) {
      errors.push({ type: ProductErrorType.MISSING, property: 'contents', payload: { ...payloadData } });
    }
    item.contents
      ?.map((c, i) => Content.validate(c, i, { ...payloadData }))
      .reduce((flattened, subError) => flattened.concat(subError), [])
      .forEach(error => {
        errors.push(error);
      });

    return errors;
  }
}

export class VerticalMenuProgression {
  verticalMenuProgressionList: VerticalMenuProgressionItem[];

  constructor(progression?: VerticalMenuProgression) {
    this.verticalMenuProgressionList = (progression?.verticalMenuProgressionList || []) //
      .map(v => new VerticalMenuProgressionItem(v));
  }
}

export class VerticalMenuProgressionItem {
  itemUuid: string;

  constructor(verticalMenuProgression: VerticalMenuProgressionItem) {
    this.itemUuid = verticalMenuProgression.itemUuid;
  }
}
